import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { Success } from '../../../images/Success';

import s from './ContactDescription.scss';

export function ContactDescription() {
	useStyles(s);

	return (
		<div className="sl-teams-contact-description">
			<div className="sl-teams-contact-description__logo">
				<img
					src="https://blob.sololearn.com/web-assets/teams-logo.png"
					alt="teams-logo"
				/>
			</div>
			<div className="sl-teams-contact-description__title">
				Grow your business with limitless learning for every employee
			</div>
			<div className="sl-teams-contact-description__details">
				{[
					'Bite-sized lessons staff actually apply in their roles',
					'Interactive interface for fast, friction-free learning',
					'Custom dashboard to see progress and acquired skills',
				].map((text, index) => (
					<div
						className="sl-teams-contact-description__detail"
						key={index}
					>
						<div className="sl-teams-contact-description__detail__icon">
							<Success />
						</div>
						<div className="sl-teams-contact-description__detail__text">
							{text}
						</div>
					</div>
				))}
			</div>
		</div>
	);
}
